<template>
  <div>
    <b-list-group>
      <b-list-group-item
        v-for="item in lista"
        :key="item.id"
        ref="table"
        style="cursor:pointer;"
      >
        <b-row class="mb-2">
          <b-col md="8">
            <h6 class="display-cuil">{{ item.InformacionPersonal.Cuil }}</h6>
            <h5 class="display-name">{{ item.DisplayName.toUpperCase() }}</h5>
          </b-col>
        </b-row>

        <b-row class="mb-3">
          <b-col md="6">
            <small><strong>Teléfono:</strong></small>
            <small>{{
              item.InformacionPersonal.Telefono
                ? item.InformacionPersonal.Telefono
                : "Completar Telefono"
            }}</small
            ><br />

            <small><strong>Email:</strong></small>
            <small>{{
              item.InformacionPersonal.Email
                ? item.InformacionPersonal.Email
                : "Completar Email"
            }}</small
            ><br />
            <small><strong>Domicilio:</strong></small>
            <small>{{ item.InformacionPersonal.Domicilio }}</small>
          </b-col>
          <b-col md="6">
            <small><strong>Fecha de Ingreso:</strong></small>
            <small>{{ item.FechaIngreso | moment("DD-MM-YYYY") }}</small>
            <br />
            <small><strong>Fecha de Nacimiento:</strong></small>
            <small>{{
              item.InformacionPersonal.FechaNacimiento | moment("DD-MM-YYYY")
            }}</small>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-alert
              variant="danger"
              :show="datosIncompletos(item.InformacionPersonal)"
              class="mt-4 text-center"
            >
              <small>Completar información personal en SAED Digital</small>
            </b-alert>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <span v-for="cp in cargosActivos(item.CargoPersonal)" :key="cp.Id"> {{ cp.DisplayCargoEstablecimiento }} {{ cp.EstadoCargoPersonal }} <br></span>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12" class="d-flex">
            <b-button
              variant="outline-success"
              size="sm"
              class="mt-2 float-right"
              @click="crearSolicitud(item)"
              v-if="datosIncompletos(item.InformacionPersonal) == false"
              >Crear Solicitud</b-button
            >
          </b-col>
        </b-row>
      </b-list-group-item>
    </b-list-group>
  </div>
</template>

<script>
import { createHelpers } from 'vuex-map-fields';
const { mapFields: mapFormBuscarPersonalFields } = createHelpers({
  getterType: 'FormBuscarPersonal/getFormBuscarPersonalField',
  mutationType: 'FormBuscarPersonal/updateFormBuscarPersonalField',
});
export default {
  name: "ListaPersonal",
  props: {
    lista: Array
  },
  computed: {
    ...mapFormBuscarPersonalFields(['Personal', 'ListaCargoPersonal', 'Dni'])
  },
  components: { },
  methods: {
    crearSolicitud(item){
      console.log('crearSolicitud', item);
      this.Personal = item;
      if (item.CargoPersonal.length > 0) {
        this.ListaCargoPersonal = item.CargoPersonal;
      }
      this.$router.push({ name: 'registrarsolicitudpersonal', params: {  } })
    },
    cargosActivos(cargoPersonal) {
      return cargoPersonal.filter(
        c =>
          c.EstadoCargoPersonal === "Activo" ||
          c.EstadoCargoPersonal === "EnLicencia"
      );
    },
    datosIncompletos(infoPersonal) {
      let incompletos = false;
      if (infoPersonal.Email === "" || infoPersonal.Email === null) {
        incompletos = true;
      } else if (
        infoPersonal.Domicilio === "" ||
        infoPersonal.Domicilio === null
      ) {
        incompletos = true;
      } else if (
        infoPersonal.Telefono === "" ||
        infoPersonal.Telefono === null
      ) {
        incompletos = true;
      }
      return incompletos;
    }
  }
};
</script>

<style  scoped>
.list-group-item:hover {
  border-left: 3px solid #41b883;
  background-color: #f1f1f1;
}
</style>



// WEBPACK FOOTER //
// src/components/common/ListaPersonal.vue